(function () {
  'use strict';

  // -----------------------------------------------------------------------
  // The product grid inside <product-recommendations> only exists after
  // Dawn's stock product-recommendations.js fetches it via AJAX and injects
  // it (recommendations.performed is false on the initial server render).
  // We watch for that injection with a MutationObserver instead of assuming
  // the content is already there when this script runs.
  // -----------------------------------------------------------------------

  function getSlides(track) {
    return Array.prototype.slice.call(track.querySelectorAll('[data-related-card]'));
  }

  function trackGap(track) {
    var styles = getComputedStyle(track);
    return parseFloat(styles.columnGap || styles.gap || 0) || 0;
  }

  function visibleCount(track) {
    var slides = getSlides(track);
    if (!slides.length) return 1;
    var trackWidth = track.clientWidth;
    var slideWidth = slides[0].getBoundingClientRect().width;
    return Math.max(1, Math.round(trackWidth / (slideWidth + trackGap(track))));
  }

  function pageCount(track) {
    var slides = getSlides(track);
    var perView = visibleCount(track);
    return Math.max(1, Math.ceil(slides.length / perView));
  }

  function currentPage(track) {
    var perView = visibleCount(track);
    var slides = getSlides(track);
    if (!slides.length) return 0;
    var slideWidth = slides[0].getBoundingClientRect().width;
    var index = Math.round(track.scrollLeft / (slideWidth + trackGap(track)));
    return Math.min(pageCount(track) - 1, Math.floor(index / perView));
  }

  function scrollToPage(track, page) {
    var slides = getSlides(track);
    var perView = visibleCount(track);
    var index = Math.min(slides.length - 1, Math.max(0, page) * perView);
    var target = slides[index];
    if (!target) return;
    track.scrollTo({ left: target.offsetLeft - track.offsetLeft, behavior: 'smooth' });
  }

  function bindCarousel(root, track, prevBtn, nextBtn, dotsWrap) {
    function buildDots() {
      if (!dotsWrap) return;
      dotsWrap.innerHTML = '';
      var total = pageCount(track);
      if (total <= 1) return;
      for (var i = 0; i < total; i++) {
        var dot = document.createElement('button');
        dot.type = 'button';
        dot.className = 'related-accessories__dot';
        dot.setAttribute('aria-label', 'Go to slide ' + (i + 1));
        (function (page) {
          dot.addEventListener('click', function () {
            scrollToPage(track, page);
          });
        })(i);
        dotsWrap.appendChild(dot);
      }
      updateDots();
    }

    function updateDots() {
      var page = currentPage(track);
      if (dotsWrap) {
        var dots = dotsWrap.querySelectorAll('.related-accessories__dot');
        dots.forEach(function (dot, i) {
          dot.classList.toggle('is-active', i === page);
        });
      }
      if (prevBtn) prevBtn.disabled = page <= 0;
      if (nextBtn) nextBtn.disabled = page >= pageCount(track) - 1;
    }

    buildDots();

    if (prevBtn) {
      prevBtn.addEventListener('click', function () {
        scrollToPage(track, currentPage(track) - 1);
      });
    }
    if (nextBtn) {
      nextBtn.addEventListener('click', function () {
        scrollToPage(track, currentPage(track) + 1);
      });
    }

    var scrollTimer;
    track.addEventListener('scroll', function () {
      clearTimeout(scrollTimer);
      scrollTimer = setTimeout(updateDots, 80);
    });

    var resizeTimer;
    window.addEventListener('resize', function () {
      clearTimeout(resizeTimer);
      resizeTimer = setTimeout(buildDots, 150);
    });
  }

  function bindCart(root) {
    var addCartUrl = root.getAttribute('data-cart-add-url');
    var changeCartUrl = root.getAttribute('data-cart-change-url');
    var cartUrl = root.getAttribute('data-cart-url');

    function refreshCartBubble() {
      fetch(cartUrl + '.js')
        .then(function (res) {
          return res.json();
        })
        .then(function (cart) {
          var bubbleWrap = document.querySelector('.cart-count-bubble');
          var bubble = bubbleWrap && bubbleWrap.querySelector('span[aria-hidden]');
          if (bubbleWrap) {
            if (bubble) bubble.textContent = cart.item_count;
            bubbleWrap.hidden = cart.item_count === 0;
          }
        })
        .catch(function () {});
    }

    var cartWraps = root.querySelectorAll('[data-related-cart-wrap]');
    cartWraps.forEach(function (wrap) {
      var variantId = wrap.getAttribute('data-variant-id');
      var form = wrap.querySelector('[data-related-add-form]');
      var stepper = wrap.querySelector('[data-related-stepper]');
      var countEl = wrap.querySelector('[data-related-count]');
      var decreaseBtn = wrap.querySelector('[data-related-decrease]');
      var increaseBtn = wrap.querySelector('[data-related-increase]');
      var addButton = wrap.querySelector('[data-related-add-button]');
      var count = 1;

      function showStepper() {
        if (form) form.hidden = true;
        if (stepper) stepper.hidden = false;
      }

      function showForm() {
        if (form) form.hidden = false;
        if (stepper) stepper.hidden = true;
        count = 1;
        if (countEl) countEl.textContent = count;
      }

      function setCount(next) {
        count = next;
        if (countEl) countEl.textContent = count;
      }

      if (form) {
        form.addEventListener('submit', function (evt) {
          evt.preventDefault();
          if (!addCartUrl) return;
          if (addButton) addButton.disabled = true;
          fetch(addCartUrl + '.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: 1 })
          })
            .then(function (res) {
              if (!res.ok) throw new Error('add failed');
              return res.json();
            })
            .then(function () {
              setCount(1);
              showStepper();
              refreshCartBubble();
              document.dispatchEvent(new CustomEvent('cart:refresh'));
            })
            .catch(function () {
              form.submit();
            })
            .finally(function () {
              if (addButton) addButton.disabled = false;
            });
        });
      }

      function changeQuantity(newCount) {
        if (!changeCartUrl) return;
        fetch(changeCartUrl + '.js', {
          method: 'POST',
          headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
          body: JSON.stringify({ id: variantId, quantity: newCount })
        })
          .then(function (res) {
            return res.json();
          })
          .then(function () {
            refreshCartBubble();
            document.dispatchEvent(new CustomEvent('cart:refresh'));
            if (newCount <= 0) showForm();
          })
          .catch(function () {});
      }

      if (increaseBtn) {
        increaseBtn.addEventListener('click', function () {
          var next = count + 1;
          setCount(next);
          changeQuantity(next);
        });
      }

      if (decreaseBtn) {
        decreaseBtn.addEventListener('click', function () {
          var next = Math.max(0, count - 1);
          setCount(next);
          changeQuantity(next);
        });
      }
    });
  }

  function init(root) {
    if (!root || root.getAttribute('data-ra-initialized') === 'true') return;

    var track = root.querySelector('[data-related-track]');
    if (!track) return; // recommendations haven't been injected into the DOM yet

    root.setAttribute('data-ra-initialized', 'true');

    var prevBtn = root.querySelector('[data-related-prev]');
    var nextBtn = root.querySelector('[data-related-next]');
    var dotsWrap = root.querySelector('[data-related-dots]');

    bindCarousel(root, track, prevBtn, nextBtn, dotsWrap);
    bindCart(root);
  }

  function watch(root) {
    // Covers the (rare) case where recommendations were already in the DOM
    init(root);

    var pr = root.querySelector('product-recommendations');
    if (!pr) return;

    var observer = new MutationObserver(function () {
      init(root);
    });
    observer.observe(pr, { childList: true });
  }

  function boot(scope) {
    scope.querySelectorAll('[data-related-accessories]').forEach(watch);
  }

  boot(document);

  document.addEventListener('shopify:section:load', function (event) {
    boot(event.target);
  });
})();